import { combineReducers } from "redux";
import auth from "./auth/reducer";
import cardData from "./admin/CardInvoice/reducer";
import sim from "./admin/SimInvoice/reducer";
import report from "./admin/Report/reducer";
import invoiceListData from "./admin/CustomerInvoiceList/reducer"
import userData from "./admin/UserList/reducer"
import common from "./common/reducer"
import modalReducer from './modal/reducer'
import users from "./admin/Users/reducer"

const appReducer = combineReducers({
  auth,
  cardData,
  sim,
  report,
  invoiceListData,
  userData,
  common,
  users,
  modalReducer
});

const reducers = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === "DESTROY_SESSION") state = undefined;

  return appReducer(state, action);
};

export default reducers;
